<template>
	<svg
		width="2px"
		height="2px"
		viewBox="0 0 2 2"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="dot icon"
	>
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g transform="translate(-516.000000, -386.000000)" fill="#4F5053">
				<circle cx="517" cy="387" r="1"></circle>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'Dot',
}
</script>
<style scoped>
svg {
	width: 3px;
	height: 3px;
}
</style>
